<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'

import {
  GET_VEHICLE_ODOMETER,
  UPDATE_VEHICLE_ODOMETER,
} from '@/services/api/setting/odoometer/Odoometer'
import { Helper } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import datePickerLang from '@/helpers/date-picker-lang'
import McButton from '@/components/McButton'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    vehicleOdometer: {
      query: GET_VEHICLE_ODOMETER,
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.vehicleOdometer.vehicleOdometer.length
          this.filteredItems = data.vehicleOdometer.vehicleOdometer
        }
      },
    },
  },
  validations: {
    form: {
      fullname: { required },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      pembaruan: {
        options: [
          { value: 120000, label: '2 Menit' },
          { value: 300000, label: '5 Menit' },
          { value: 0, label: 'Nonaktif' },
        ],
        value: { value: 120000, label: '2 Menit' },
      },
      refreshInterval: null,
      vehicleOdometer: {
        vehicleOdometer: [],
      },
      selected: {
        odometer: [],
      },
      selectedModel: {
        odometer: [],
      },
      allSelected: {
        odometer: false,
      },
      indeterminate: {
        odometer: true,
      },
      show_model: null,
      filteredItems: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'groupNameService',
      fleetType: null,
      manufactur: null,
      barMinValueOdo: 1,
      barMaxValueOdo: 100,

      modalData: {
        licensePlate: null,
        vehicleType: { type: null },
        odometer: null,
        vehicleStatus: null,
        odometerEditedOn: null,
      },

      modalInfo: {
        odometer: null,
        odometerEditedOn: null,
        vehicleStatus: null,
      },

      state: {
        odometer: true,
        odometerEditedOn: true,
        odometerMinus: true,
        odometerDecimal: true,
      },

      timePickerOptions: {
        start: '00:00',
        step: '00:10',
        end: '23:50',
        format: 'HH:mm',
      },
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.vehicleOdometer.vehicleOdometer.length
    },

    totalTrue() {
      return this.selectedModel.odometer.filter((c) => c === true)
    },

    title() {
      return this.$t('setting.list.odometer.title')
    },

    subTitle() {
      return `${this.$t('setting.list.odometer.description')} ${this.pembaruan.value.label}.`
    },

    datePickerLang() {
      return datePickerLang()
    },

    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('setting.list.odometer.numberPlate'),
          sortable: true,
        },
        {
          key: 'vehicleType.type',
          label: this.$t('setting.list.odometer.fleetType'),
          sortable: true,
        },
        {
          key: 'odometer',
          label: this.$t('setting.list.odometer.odometerNow') + ' (KM)',
          sortable: true,
        },
        {
          key: 'odometerEditedOn',
          label: this.$t('setting.list.odometer.odometerTime'),
          sortable: true,
        },
        {
          key: 'vehicleStatus',
          label: this.$t('setting.list.odometer.odometerLast'),
          sortable: true,
        },
      ]
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.odometer.title'),
        },
      ]
    },
  },

  created() {
    this.refreshData()
  },

  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    refreshData() {
      clearInterval(this.refreshInterval)
      if (this.pembaruan.value.value != 0) {
        this.$apollo.queries.vehicleOdometer.refetch()
        this.refreshInterval = setInterval(() => {
          if (this.$route.path === '/setting/odometer') {
            this.$apollo.queries.vehicleOdometer.refetch()
          } else {
            clearInterval(this.refreshInterval)
          }
        }, this.pembaruan.value.value)
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    checkDate() {
      let comparison = this.modalData.vehicleStatus ? this.modalData.vehicleStatus.lastPacket : null

      if (!comparison) {
        return true
      }

      if (this.momentToISOString(this.modalData.odometerEditedOn) > comparison) {
        this.modalData.odometerEditedOn = null
        return false
      }

      return true
    },

    odometerDecimalValidity() {
      let odometerDecimal = this.modalData.odometer?.toString() ?? ''
      odometerDecimal = odometerDecimal.split(',')[1] ?? ''
      if (odometerDecimal.length > 2) {
        return false
      }
      return true
    },

    showModal(data) {
      if (!this.hasAccess(['vehicle_odometer:update'])) {
        return
      }
      this.modalInfo.vehicleStatus = data.vehicleStatus
      this.modalInfo.odometer = data.odometer

      this.modalData = { ...data }
      this.modalData.odometer = this.modalData.odometer.toString().replaceAll('.', ',')
      this.state.odometerMinus = true

      let odometerEdited = null
      if (data.vehicleStatus && data.odometerEditedOn) {
        odometerEdited =
          this.momentYmDHms(data.vehicleStatus.lastPacket) >
          this.momentYmDHms(data.odometerEditedOn)
            ? this.momentYmDHms(data.vehicleStatus.lastPacket)
            : this.momentYmDHms(data.odometerEditedOn)
      } else {
        odometerEdited = data.vehicleStatus
          ? this.momentYmDHms(data.vehicleStatus.lastPacket)
          : data.odometerEditedOn
          ? this.momentYmDHms(data.odometerEditedOn)
          : null
      }

      this.modalInfo.odometerEditedOn = odometerEdited
      this.modalData.odometerEditedOn = odometerEdited

      this.$bvModal.show('reqListService')
    },

    resetModal() {
      this.modalData = {
        licensePlate: null,
        vehicleType: { type: null },
        odometer: null,
        vehicleStatus: null,
      }

      this.state = {
        odometer: true,
        odometerEditedOn: true,
        odometerMinus: true,
        odometerDecimal: true,
      }
    },

    UpdateValuesOdo(e) {
      this.barMinValueOdo = e.minValue
      this.barMaxValueOdo = e.maxValue
    },

    checkFormValidity() {
      const odometer = parseFloat(this.modalData.odometer.toString().replaceAll(',', '.'))
      this.state.odometer = this.modalData.odometer ? true : false
      this.state.odometerEditedOn = this.modalData.odometerEditedOn ? true : false
      this.state.odometerMinus = odometer.length > 0 ? odometer >= 0 : true
      this.state.odometerDecimal = this.odometerDecimalValidity()
      return (
        this.state.odometer &&
        this.state.odometerEditedOn &&
        this.state.odometerMinus &&
        this.state.odometerDecimal
      )
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      const input = {
        id: this.modalData.id,
        odometer: parseFloat(this.modalData.odometer.toString().replaceAll(',', '.')),
        odometerEditedOn: this.momentToISOString(this.modalData.odometerEditedOn),
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_VEHICLE_ODOMETER,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateVehicleOdometer.isSuccessful) {
            this.$apollo.queries.vehicleOdometer.refetch()
            this.$mcToast.success(this.$t('liveView.text.dataSaved'))
            this.$bvModal.hide('reqListService')
          } else {
            return this.$mcToast.error(response.data.updateVehicleOdometer.message)
          }
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader
        :title="title"
        :subTitle="subTitle"
        :items="breadcrumbItems"
        hasBreadcrumb
        hasBackButton
      />

      <div class="mc-dashboard">
        <div class="mc-table-filter text-end">
          <div class="mc-table-view">
            <p class="mc-label">
              {{ $t('setting.list.odometer.update') }}
            </p>
            <multiselect
              v-model="pembaruan.value"
              :options="pembaruan.options"
              label="label"
              placeholder="Pilih Pembaruan"
              @input="refreshData"
            />
            <McButton
              variant="secondary"
              size="sm"
              icon="icon-outline_refresh"
              text=""
              @click="refreshData"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="clearfix">
          <!-- Search -->
          <div class="float-end">
            <div class="mc-table-view">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label
                  class="d-inline-flex align-items-center mc-table-view__search ms-2"
                  @click="focusSearch"
                >
                  <i class="mc-fa fas fa-search" />
                  <b-form-input
                    ref="searchInput"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="form-control ms-2"
                  />
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :items="vehicleOdometer.vehicleOdometer"
            :fields="fields"
            class="datatables"
            responsive="md"
            sort-by="licensePlate"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :busy="$apollo.queries.vehicleOdometer.loading"
            @filtered="onFiltered"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>
            <template #cell(licensePlate)="data">
              <strong
                :class="
                  hasAccessAll(['vehicle_odometer:read', 'vehicle_odometer:update'])
                    ? 'text-primary'
                    : null
                "
                @click="showModal(data.item)"
              >
                {{ data.item.licensePlate }}
              </strong>
            </template>
            <template #cell(odometer)="data">
              <p class="my-0">
                {{ Number(data.item.odometer.toFixed(2)).toLocaleString('id-ID') }}
              </p>
            </template>
            <template #cell(odometerEditedOn)="data">
              <p class="my-0">
                {{
                  data.item.odometerEditedOn
                    ? momentDateShortMonth(data.item.odometerEditedOn)
                    : '-'
                }}
              </p>
              <p v-if="data.item.odometerEditedOn" class="text-muted my-0">
                {{ momentTime(data.item.odometerEditedOn) }}
              </p>
            </template>

            <template #cell(vehicleStatus)="data">
              <p class="my-0">
                {{
                  data.item.vehicleStatus
                    ? momentDateShortMonth(data.item.vehicleStatus.lastPacket)
                    : data.item.odometerEditedOn
                    ? momentDateShortMonth(data.item.odometerEditedOn)
                    : '-'
                }}
              </p>
              <p class="text-muted my-0">
                {{
                  data.item.vehicleStatus
                    ? momentTime(data.item.vehicleStatus.lastPacket)
                    : data.item.odometerEditedOn
                    ? momentTime(data.item.odometerEditedOn)
                    : '-'
                }}
              </p>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  v-model="perPage"
                  class="form-select form-select-sm"
                  size="sm"
                  :options="pageOptions"
                />
                {{ $t('global.entry') }}.
                <p>
                  {{ $t('global.show') }}
                  <strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong>
                  -
                  <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong>
                  {{ $t('global.object.of') }}
                  <strong>{{ filteredItems.length }}.</strong>
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="reqListService"
      class="mc-modal"
      :title="$t('setting.list.odometer.adjustment')"
      size="lg"
      centered
      scrollable
      no-stacking
      @hidden="resetModal"
      @click="handleOk"
    >
      <form ref="form" class="mc-form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block mc-span__label">{{
                $t('setting.list.odometer.numberPlate')
              }}</span>
              <strong class="mc-strong__label">{{ modalData.licensePlate }}</strong>
            </div>
          </b-col>

          <b-col md="2">
            <div class="mb-3">
              <span class="d-block mc-span__label">{{
                $t('setting.list.odometer.numberPlate')
              }}</span>
              <strong class="mc-strong__label">{{ modalData.vehicleType.type }}</strong>
            </div>
          </b-col>

          <b-col md="3">
            <div class="mb-3">
              <span class="d-block mc-span__label">{{
                $t('setting.list.odometer.odometerNow')
              }}</span>
              <strong class="mc-strong__label">{{ `${modalInfo.odometer} Km` }}</strong>
            </div>
          </b-col>

          <b-col md="5">
            <div class="mb-3">
              <span class="d-block mc-span__label">{{
                $t('setting.list.odometer.odometerLast')
              }}</span>
              <strong class="mc-strong__label">
                {{
                  modalInfo.odometerEditedOn
                    ? momentDateShortMonth(modalInfo.odometerEditedOn)
                    : '-'
                }}
                |
                {{ modalInfo.odometerEditedOn ? momentTime(modalInfo.odometerEditedOn) : '-' }}
              </strong>
            </div>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('setting.list.odometer.adjustment')"
              label-for="settingOdo"
            >
              <b-form-input
                id="settingOdo"
                v-model="modalData.odometer"
                trim
                type="text"
                placeholder="110,32"
                :formatter="numberIdFormatter"
                :state="state.odometer && state.odometerMinus && state.odometerDecimal"
                required
              />
              <div
                v-if="state.odometer && state.odometerMinus && state.odometerDecimal"
                class="custom-input-help-text input-md"
              >
                <label class="custom-required-help-text">
                  <span>* </span>{{ $t('global.validation.required') }}
                </label>
              </div>
              <div
                v-if="!state.odometerMinus || !state.odometerDecimal || !state.odometer"
                class="invalid-feedback"
                style="display: block"
              >
                <span v-if="!state.odometerMinus">
                  {{ $t('setting.list.odometer.odometerLimit') }}
                </span>
                <span v-if="!state.odometerDecimal">
                  {{ $t('setting.list.odometer.odometerDecimalValid') }}
                </span>
                <span v-if="!state.odometer">
                  {{ $t('setting.list.odometer.odometerRequired') }}
                </span>
              </div>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('setting.list.odometer.odometerTime')"
              label-for="settingOdoTime"
            >
              <date-picker
                v-model="modalData.odometerEditedOn"
                type="datetime"
                format="DD MMM YYYY - HH:mm"
                value-type="YYYY-MM-DD HH:mm:ss"
                :time-picker-options="timePickerOptions"
                placeholder="Pilih Tanggal"
                :state="state.odometerEditedOn"
                required
                :lang="datePickerLang"
              />
              <div v-if="state.odometerEditedOn" class="custom-input-help-text input-md">
                <label class="custom-required-help-text">
                  <span>* </span>{{ $t('global.validation.required') }}
                </label>
              </div>
              <div v-if="!state.odometerEditedOn" class="invalid-feedback" style="display: block">
                <span v-if="!state.odometerEditedOn">
                  {{ $t('setting.list.odometer.required') }}
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.cancel')"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.save')" @click="handleOk" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
